import { createPaginationState } from '@/common/pagination/types.ts';

export const [liftPaginationAtom, resetLiftPaginationOnFilterChangeAtom] =
  createPaginationState();
